import React from "react";
import publishedBooksData from "../components/publication/data/publishedBooks.json";
import BookCover from "../img/preserving-identity-cover.webp";
import "./PublishedBooks.scss";

const PublishedBooks = () => {
  const publishedBooks = publishedBooksData.filter((item) => item.type === "book");
  const editedBooks = publishedBooksData.filter((item) => item.type === "edited_book");
  const monographs = publishedBooksData.filter((item) => item.type === "monograph");

  const renderItems = (items) => {
    return items.map((item) => (
      <article className="published-book-card" key={item.id}>
        <div className="published-book-top">
          <div>
            <h3>{item.title}</h3>
            <p className="published-book-meta">
              {item.authors} | {item.publisher} | {item.year}
            </p>
          </div>
          <a
            href={item.link}
            target="_blank"
            rel="noopener noreferrer"
            className="published-book-link"
          >
            View Publication
          </a>
        </div>
        <p>{item.description}</p>
      </article>
    ));
  };

  return (
    <main className="published-books-page">
      <header className="published-books-header">
        <h1>Published Books & Works</h1>
        <p>
          Explore our published books, edited volumes, and monographs with links
          to where they are published.
        </p>
      </header>

      <section className="published-books-section published-books-release">
        <h2>Latest Release</h2>
        {publishedBooks.length > 0 ? (
          <article className="published-book-card release-card" key={publishedBooks[0].id}>
            <div className="release-badge">New Release</div>
            <div className="release-grid">
              <img
                src={BookCover}
                alt={`${publishedBooks[0].title} cover`}
                className="release-cover"
              />
              <div className="release-copy">
                <h3>{publishedBooks[0].title}</h3>
                <p className="published-book-meta">
                  {publishedBooks[0].authors} | {publishedBooks[0].publisher} | {publishedBooks[0].year}
                </p>
                <p>{publishedBooks[0].description}</p>
                <a
                  href={publishedBooks[0].link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="published-book-link"
                >
                  View Publication
                </a>
              </div>
            </div>
          </article>
        ) : (
          <p>No published book entries available yet.</p>
        )}
      </section>

      <section className="published-books-section">
        <h2>Edited Books</h2>
        {editedBooks.length > 0 ? (
          <article className="published-book-card release-card" key={editedBooks[0].id}>
            <div className="release-badge">New Release</div>
            <div className="release-grid">
              <img
                src={BookCover}
                alt={`${editedBooks[0].title} cover`}
                className="release-cover"
              />
              <div className="release-copy">
                <h3>{editedBooks[0].title}</h3>
                <p className="published-book-meta">
                  {editedBooks[0].authors} | {editedBooks[0].publisher} | {editedBooks[0].year}
                </p>
                <p>{editedBooks[0].description}</p>
                <a
                  href={editedBooks[0].link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="published-book-link"
                >
                  View Publication
                </a>
              </div>
            </div>
          </article>
        ) : (
          <p>No edited book entries available yet.</p>
        )}
      </section>

      <section className="published-books-section">
        <h2>Monograph</h2>
        {monographs.length > 0 ? (
          renderItems(monographs)
        ) : (
          <p>No monograph entries available yet.</p>
        )}
      </section>
    </main>
  );
};

export default PublishedBooks;





